import React from "react";
import { Grid } from "@material-ui/core";
import PaymentGatewayComp from "./PaymentGatewayComp";
const PaymentGateway = ({ classes, settings, setSettings }) => {
  return (
    <Grid container direction="row">
      <PaymentGatewayComp
        classes={classes}
        settings={settings}
        setSettings={setSettings}
      />
    </Grid>
  );
};

export default PaymentGateway;
